export const criminalLawConst = {
  path: "/single-programs/criminal-law",
  title: "ФАКУЛЬТЕТ ПРАВА — УГОЛОВНОЕ ПРАВО",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Уголовное право — защита общества и правосудие в действии</h2>
      <p>
        Программа по уголовному праву формирует специалистов, готовых защищать закон, обеспечивать правопорядок и справедливость. Это
        направление подходит тем, кто хочет глубоко понять природу преступности, механизмы расследования и работу судебной системы.
      </p>
      <p>
        Студенты изучают уголовное и уголовно-процессуальное право, криминологию, криминалистику, судебную экспертизу и международные
        стандарты правосудия.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Уголовное право: общая и особенная части</li>
        <li>Уголовный процесс и права обвиняемых</li>
        <li>Криминалистика и методы расследования</li>
        <li>Судебная практика и прецеденты</li>
        <li>Организация работы прокуратуры и суда</li>
        <li>Международное уголовное право</li>
        <li>Правоохранительные органы ЕС</li>
        <li>Этика и ответственность в юридической практике</li>
      </ul>
      <p>
        В рамках обучения предусмотрены практические занятия, моделирование судебных процессов, участие в стажировках и консультациях с
        практикующими юристами.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Адвокат по уголовным делам (при наличии лицензии)</li>
        <li>Прокурор или помощник прокурора</li>
        <li>Следователь или криминалист</li>
        <li>Юрист в правоохранительных органах</li>
        <li>Специалист по уголовному праву в международных организациях</li>
      </ul>
      <h2>Средний доход в Европе:</h2>
      <p>
        от <strong>€55,000 до €100,000 в год</strong> — в зависимости от юрисдикции и практики.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, признанный в странах ЕС</li>
        <li>Программа доступна на русском и английском языках</li>
        <li>Очная или дистанционная форма обучения</li>
        <li>Подготовка к юридической практике в международной среде</li>
        <li>Стажировки и карьерная поддержка</li>
        <li>Индивидуальное сопровождение студентов</li>
      </ul>
      <p>Уголовное право — это выбор тех, кто стоит на страже закона.</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам на каждом этапе — от выбора направления до подачи документов.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Уголовное право — защита общества и правосудие в действии
    Программа по уголовному праву формирует специалистов, готовых защищать закон, обеспечивать правопорядок и справедливость. Это направление подходит тем, кто хочет глубоко понять природу преступности, механизмы расследования и работу судебной системы.
    Студенты изучают уголовное и уголовно-процессуальное право, криминологию, криминалистику, судебную экспертизу и международные стандарты правосудия.
    Что вы будете изучать?
    • Уголовное право: общая и особенная части
    • Уголовный процесс и права обвиняемых
    • Криминалистика и методы расследования
    • Судебная практика и прецеденты
    • Организация работы прокуратуры и суда
    • Международное уголовное право
    • Правоохранительные органы ЕС
    • Этика и ответственность в юридической практике
    В рамках обучения предусмотрены практические занятия, моделирование судебных процессов, участие в стажировках и консультациях с практикующими юристами.
    Кем можно работать после окончания?
    • Адвокат по уголовным делам (при наличии лицензии)
    • Прокурор или помощник прокурора
    • Следователь или криминалист
    • Юрист в правоохранительных органах
    • Специалист по уголовному праву в международных организациях
    Зарплата в Европе: от €55,000 до €100,000 в год — в зависимости от юрисдикции и практики.
    Почему выбирают нас?
    • Европейский диплом, признанный в странах ЕС
    • Программа доступна на русском и английском языках
    • Очная или дистанционная форма обучения
    • Подготовка к юридической практике в международной среде
    • Стажировки и карьерная поддержка
    • Индивидуальное сопровождение студентов
    Уголовное право — это выбор тех, кто стоит на страже закона.
    Как поступить?
    Приёмная комиссия поможет вам на каждом этапе — от выбора направления до подачи документов.
  `,
};
